export default "__VITE_ASSET__03cf79b4__"